import { Button, makeStyles } from '@material-ui/core'
import { COLORS } from 'src/utils/Themes/colors'
import {
  getPolicyStatus,
  getProviderImage,
  getStatusButtonClass,
  isHealthInsurance,
} from 'src/utils/commonMethods'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { Grid } from '@mui/material'

const AllPolicies = ({ activePolicy }) => {
  const classes = useStyles()

  return (
    <>
      <Grid
        container
        spacing={1}
        direction='column'
        className={classes.policyContainer}
      >
        <Grid item xs={12} sm={12} lg={12} flexGrow={1}>
          <img
            src={getProviderImage(activePolicy)}
            className={classes.providerImage}
            alt='provider'
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={12}>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.provider}
            alignItems={'center'}
          >
            {activePolicy?.provider ? activePolicy?.provider?.name : '-'}
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.title}
            alignItems={'center'}
          >
            {activePolicy?.insuranceType}
          </Grid>
          {isHealthInsurance(activePolicy?.insuranceType) && (
            <Grid
              item
              xs={12}
              sm={12}
              lg={12}
              className={classes.policyDetails}
            >
              <span className={classes.sumInsuredTableText1}>
                Family Definition :
              </span>{' '}
              <span className={classes.sumInsuredTableText1Bold}>
                {activePolicy?.familyDefinition
                  ? activePolicy?.familyDefinition
                  : '-'}
              </span>
            </Grid>
          )}
          <Grid item xs={12} sm={12} lg={12} className={classes.policyDetails}>
            <span className={classes.sumInsuredTableText1}>Sum Insured :</span>
            <span className={classes.sumInsuredTableText1Bold}>
              {activePolicy?.sumAssured !== null
                ? formatToINR(activePolicy?.sumAssured?.text)
                : '0'}
            </span>
          </Grid>
          <Grid item xs={12} sm={12} lg={12} className={classes.policyDetails}>
            <span className={classes.sumInsuredTableText1}>Policy No:</span>{' '}
            <span className={classes.sumInsuredTableText1Bold}>
              {activePolicy?.policyNumber !== null
                ? activePolicy?.policyNumber
                : '-'}
            </span>
          </Grid>

          <Grid
            item
            xs={12}
            sm={12}
            lg={12}
            className={classes.statusContainer}
            alignItems={'center'}
          >
            <Button
              className={getStatusButtonClass(activePolicy?.status)}
              disabled
            >
              {getPolicyStatus(activePolicy?.status)}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default AllPolicies

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
    alignItems: 'center',
    backgroundColor: 'linear-gradient(45deg, #eeeeee 0%,#ffffff 100%)',
    justifyContent: 'space-around',
    padding: '25px 5px',
  },
  title: {
    fontSize: '10px',
    fontWeight: 'bold',
    textAlign: 'center !important',
    color: COLORS.BLACK,
    '& button': {
      marginTop: '15px',
    },
    '@media (min-width:1600px)': {
      fontSize: '14px',
    },
    '@media (max-width:1200px)': {
      fontSize: '9px',
    },
  },
  icon: {
    padding: '0px 0px 0px 10px',
    flexShrink: 0,
    width: '100%',
    alignItems: 'center',
  },
  policyDetailContainer: {
    display: 'flex',
    flexDirection: 'column !important',
  },
  icon1: {
    padding: '0px 0px 0px 10px',
    flexShrink: 0,
    width: '100%',
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  btn: {
    backgroundColor: COLORS.DARK_PINK,
    color: COLORS.WHITE,
    borderRadius: '60px',
    padding: '3px 16px',
    fontSize: '12px',
    width: 'max-content',
    textTransform: 'capitalize',
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
    },

    '&:hover': {
      backgroundColor: COLORS.PINK_01,
    },
  },

  policyDetails: {
    '@media (max-width:1200px)': {
      alignItems: 'center !important',
    },
  },
  sumInsuredTableText1: {
    fontWeight: '500',
    color: COLORS.GREY,
    fontSize: '12px',
    margin: '0px 0px',
    alignItems: 'center',
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
  },
  sumInsuredTableText1Bold: {
    fontWeight: '800',
    color: COLORS.GREY,
    fontSize: '12px',
    margin: '0px 0px',
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
  },
  policyContainer: {
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    background: 'linear-gradient(45deg, #eeeeee 0%,#ffffff 100%)',
    justifyContent: 'space-around',
    padding: '10px',
  },
  provider: {
    fontSize: '12px',
    fontWeight: 'bold',
    textAlign: 'center !important',
    color: COLORS.DARK_PINK,
    '@media (min-width:1600px)': {
      fontSize: '16px',
    },
    '@media (max-width:1200px)': {
      fontSize: '11px',
      alignItems: 'center !important',
    },
    '& button': {
      marginTop: '15px',
    },
  },
  statusContainer: {
    alignItems: 'center !important',
    justifyContent: 'center !important',
  },
  providerImage: {
    width: '35px',
    cursor: 'pointer',
  },
  showMoreIcon: {
    padding: '0px 10px 0px 0px',
    flexShrink: 0,
    '& svg': {
      maxWidth: '100%',
    },
    '& img': {
      maxWidth: '100%',
    },
  },
  showMoreImage: {
    width: '30px',
    cursor: 'pointer',
  },
  coverageHeading: {
    backgroundColor: 'rgba(187, 187, 187, 1)',
    color: COLORS.DARK_BLUE,
    display: 'block',
  },
  selectedPolicy: {
    background: 'none',
  },
  unSelectedPolicy: {
    background: 'linear-gradient(74.06deg, #EBEBEB 0%, #FFFFFF 100%)',
  },
  policyNumberText: {
    fontWeight: '500',
    color: COLORS.GREY,
    padding: '0px 0px 0px 10px',
    fontSize: '11px',
    margin: '0px 0px',
    whiteSpace: 'nowrap',
    '@media (min-width:1600px)': {
      fontSize: '15px',
    },
    '@media (max-width:1200px)': {
      fontSize: '10px',
      alignItems: 'center !important',
    },
  },
  policyNumberValue: {
    fontWeight: '600',
    color: COLORS.GREY,
    fontSize: '10px',
    paddingLeft: '5px',
    margin: '0px 0px',
    whiteSpace: 'nowrap',
    '@media (min-width:1600px)': {
      fontSize: '14px',
    },
    '@media (max-width:1200px)': {
      fontSize: '9px',
      alignItems: 'center !important',
    },
  },
})
